var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "69px",
    height: "69px",
    viewBox: "-4.32 -4.32 32.64 32.64",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ffffff",
    strokeWidth: 0.072,
    transform: "matrix(-1, 0, 0, 1, 0, 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.32,
    y: -4.32,
    width: 32.64,
    height: 32.64,
    rx: 16.32,
    fill: "#0f6da3",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9,17a1,1,0,1,0,1,1A1,1,0,0,0,8.9,17Zm-3,0a1,1,0,1,0,1,1A1,1,0,0,0,5.9,17Zm6,0a1,1,0,1,0,1,1A1,1,0,0,0,11.9,17ZM15,8.5a1,1,0,0,1,1.73,0,1,1,0,0,0,1.36.37A1,1,0,0,0,18.5,7.5a3,3,0,0,0-5.2,0A1,1,0,0,0,15,8.5ZM22,5.5a7,7,0,0,0-12.12,0,1,1,0,0,0,.37,1.37A1,1,0,0,0,10.7,7a1,1,0,0,0,.87-.5,5,5,0,0,1,8.66,0,1,1,0,0,0,1.37.37A1,1,0,0,0,22,5.5ZM17.9,14h-1V11a1,1,0,1,0-2,0v3H4.9a3,3,0,0,0-3,3v2a3,3,0,0,0,3,3h13a3,3,0,0,0,3-3V17A3,3,0,0,0,17.9,14Zm1,5a1,1,0,0,1-1,1H4.9a1,1,0,0,1-1-1V17a1,1,0,0,1,1-1h13a1,1,0,0,1,1,1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNode);
export default __webpack_public_path__ + "static/media/node.8517f1bf9ef660670f582bca72f9c243.svg";
export { ForwardRef as ReactComponent };